<template>
  <div class="content-source-page-component">
    <img
      class="featured-image"
      :src="getAttachmentUrl(options.featuredAttachmentId)"
      :alt="`An image representing ${options.name}`"
    >
    <div class="content-source-header">
      <img
        class="preview-image"
        :src="getAttachmentUrl(options.previewAttachmentId)"
        alt=""
        role="presentation"
      >
      <header-text :size="'sm'">
        {{ options.name }}
      </header-text>
    </div>
    <hlt-text>
      <div v-html="options.descriptionHtml" />
    </hlt-text>
  </div>
</template>

<script>
import HeaderText from '@/components/ui/header-text.vue';
import HltText from '@/components/ui/text.vue';

export default {
  components: { HeaderText, HltText },
  props: {
    options: {
      type: Object,
    },
  },
  created() {
    const attachmentIds = [];
    attachmentIds.push(this.options?.featuredAttachmentId);
    attachmentIds.push(this.options?.previewAttachmentId);
    if (attachmentIds.length > 0) {
      this.$store.dispatch('attachments/fetch', { ids: attachmentIds });
    }
  },
  methods: {
    getAttachmentUrl(attachmentId) {
      return this.$store.getters['attachments/get'][attachmentId]?.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-source-page-component {
  .featured-image {
    height: rem-calc(209);
    width: 100%;
    margin-top: 2rem;
    border-radius: 4px;
    object-fit: cover;
    object-position: center;
  }

  .content-source-header {
    display: flex;
    align-items: center;

    .preview-image {
      border-radius: 100%;
      height: rem-calc(55);
      margin: 2rem 1rem 2rem 0;
      width: rem-calc(55);
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
